import { render, staticRenderFns } from "./SeparationElementSettings.vue?vue&type=template&id=4511e95c&scoped=true"
import script from "./SeparationElementSettings.vue?vue&type=script&lang=js"
export * from "./SeparationElementSettings.vue?vue&type=script&lang=js"
import style0 from "./SeparationElementSettings.vue?vue&type=style&index=0&id=4511e95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511e95c",
  null
  
)

export default component.exports